import React from 'react';

export default function Select({
  name,
  label,
  placeholder,
  options = [],
  disabled,
  value,
  onChange,
  onBlur,
  errors,
  touched,
}) {
  return (
    <div className="w-full">
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      {disabled ? (
        <p className="text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white">
          {value ? value : <>&nbsp;</>}
        </p>
      ) : (
        <select
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          disabled={disabled}
          id={name}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        >
          <option selected="" value="">
            {placeholder}
          </option>
          {options.map((opt) => {
            return (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            );
          })}
        </select>
      )}
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
